




























import { Component, Vue } from 'vue-property-decorator';
import Menubar from '@/views/Menubar.vue';
import Zoomable from '@/layouts/Zoomable.vue';
import version from '@/store/modules/version';
import {logo} from '@/config';

@Component({
    components: {Menubar, Zoomable},
})
export default class MainLayout extends Vue {
    get outOfDate(): boolean {
        return version.outOfDate;
    }
    get logo(): string {
        return logo;
    }
}
